import { Resource } from '../i18n';

export const it: Resource = {
  misc: {
    locale: {
      box: {
        title: {
          country: 'Seleziona lingua' 
        },
      },
    },
    storeName: 'AS Roma',
  },
  welcome: 'Benvenuto su store-asroma!',
};
